import React from "react"
import { PresetImage } from "../../library/Preset"
import Toolbar from "./Toolbar"
import ToolbarItem from "./ToolbarItem"

interface OverlaysToolbarProps {
  overlays: PresetImage[]
  background: string
  handleSelect: (index: number, overlay: PresetImage) => void
}

export default function OverlaysToolbar({
  overlays,
  background,
  handleSelect,
}: OverlaysToolbarProps) {
  return (
    <Toolbar>
      {overlays.map((overlay, index) => (
        <ToolbarItem
          key={index}
          backgroundImageUrl={background}
          onClick={() => handleSelect(index, overlay)}
        >
          <img
            crossOrigin="anonymous"
            src={overlay.url}
            alt={"Overlay " + index}
          />
        </ToolbarItem>
      ))}
    </Toolbar>
  )
}
